export const utmParameters = () => {
  const run = () => {
    const fields = ['utm_source', 'utm_medium', 'utm_campaign'];
    let utm = {};

    function saveUtmParameters() {
      const urlParams = new URLSearchParams(window.location.search);
      let isUtm = false;

      fields.forEach((field) => {
        if (urlParams.get(field) !== null) {
          isUtm = true;
        }
      });

      if (isUtm) {
        fields.forEach((field) => {
          utm[field] = urlParams.get(field);
        });
        utm.timestamp = Date.now();
        localStorage.setItem('utm', JSON.stringify(utm));
      }
    }

    // save and fill
    saveUtmParameters();

    const $forms = document.querySelectorAll('form');
    $forms.forEach(($form) => {
      const $utmInputs = $form.querySelectorAll('.js-utm, input[data-utm]');
      $utmInputs.forEach(($input) => {
        const name =
          $input.getAttribute('data-utm') ||
          ($form.classList.contains('get-started-steps')
            ? $input.getAttribute('data-name')
            : $input.getAttribute('name'));

        if (fields.includes(name)) {
          utm = JSON.parse(localStorage.getItem('utm'));
          if (utm && Date.now() - utm.timestamp < 2592000000) {
            $input.value = utm[name] || '';
          }
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    // DOM already ready
    run();
  }
};
